import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ValidationRule,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_116_add_estimate: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add Estimate",
    style: {
      // backgroundColor: "#F1F8E9",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "estimation_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_estimation",
        DisplayName: "Vehicle estimation",
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 10,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Edit",
                Label: "Edit",
                BindValue: "btn_Edit",
                onPressAction: "edit",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Print",
                Label: "Print",
                BindValue: "btn_Print",
                onPressAction: "pdf_Estimation",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Estimate details",
            BindValue: "con_estimate_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Estimate No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_estimate_number",
                Json_Attribute: "est_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "EST_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Estimation date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "dt_est_date",
                Json_Attribute: "est_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                DefaultToday: true,
                maxDate: "today",
              },
              {
                IncludeLabel: true,
                Label: "Inspection No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                IsReadOnly: true,
                LookupName: "inspection_items",
                IsVerticalView: true,
              },
              {
                Label: "",
                BindValue: "veh_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "Vehicle_details",
                Parent_Field: "parentid",
              },
              {
                IncludeLabel: true,
                Label: "Remarks",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_remarks",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Estimated days",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_estimated_days",
                Json_Attribute: "est_days",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$",
                    message: "Value must be between 0 and 365",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Complaints",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "customer_remarks",
                Json_Attribute: "customer_remarks",
                componentType: ComponentType.TEXT_AREA,
                showInSummary: true,
                IsReadOnly: true,

                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Emirates Id 1",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "emirates_id_1_others",
                Json_Attribute: "emirates_id_1_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Emirates Id 2",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "emirates_id_2",
                Json_Attribute: "emirates_id_2_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Police report",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "police_report",
                Json_Attribute: "police_report_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Driving license",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "driving_license_attachment",
                Json_Attribute: "driving_license_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Others",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "file_others",
                Json_Attribute: "Others_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            Label: "Spare parts",
            TableName: "service_spare_est_req",
            Name: "service_spare_est_req",
            BindValue: "sub_Checklist",
            childControls: [
              {
                IncludeLabel: true,
                Label: "Code",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_code",
                Json_Attribute: "codeid",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                LookupName: "product_itemcode",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Qty",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_qty",
                Json_Attribute: "req_qty",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "1",
              },
              {
                IncludeLabel: true,
                Label: "Rate",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_rate",
                Json_Attribute: "rate",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                ForceExpressionUpdate: true,
                ExpressionV2: "[drp_code.sale_rate]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_rate] * [txt_qty]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "VAT%",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_vat",
                Json_Attribute: "vat_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "tax_rates",
                IncludeNotSet: false,
                Default_Value: "1",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vat_amt",
                Json_Attribute: "vat_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Net amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amt",
                Json_Attribute: "net_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Department",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_department",
                Json_Attribute: "department_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "department",
                IsVerticalView: true,
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_one",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "spare_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "spare_vat_amount",
                Json_Attribute: "spare_vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Net Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "spare_net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            Label: "Labour /Others",
            TableName: "service_labour_est",
            Name: "service_labour_est",
            BindValue: "sub_labour",
            childControls: [
              {
                IncludeLabel: true,
                Label: "Code",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_code",
                Json_Attribute: "codeid",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                LookupName: "itemcode",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Qty",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_qty",
                Json_Attribute: "qty",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "1",
              },
              {
                IncludeLabel: true,
                Label: "Rate",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_rate",
                Json_Attribute: "rate",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                ForceExpressionUpdate: true,
                ExpressionV2: "[drp_code.sale_rate]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_rate] * [txt_qty]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "VAT%",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_vat",
                Json_Attribute: "vat_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "tax_rates",
                IncludeNotSet: false,
                Default_Value: "1",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vat_amt",
                Json_Attribute: "vat_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Net amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amt",
                Json_Attribute: "net_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Department",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_department",
                Json_Attribute: "department_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: true,
                LookupName: "department",
                IsVerticalView: true,
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_4",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "labour_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "labour_vat_amount",
                Json_Attribute: "labour_vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Net Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "labour_net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            Label: "Miscellaneous",
            TableName: "estimation_miscellaneous",
            Name: "estimation_miscellaneous",
            BindValue: "sub_miscellaneous",
            LookupName: "",
            Parent_Field: "parentid",
            childControls: [
              {
                IncludeLabel: true,
                Label: "Item type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_item_type",
                Json_Attribute: "item_type",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "item_type",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Code",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_code",
                Json_Attribute: "codeid",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Item name",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "item_name",
                Json_Attribute: "item_name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Qty",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_qty",
                Json_Attribute: "qty",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "1",
              },
              {
                IncludeLabel: true,
                Label: "Rate",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_rate",
                Json_Attribute: "rate",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                ExpressionV2: "[drp_code.sale_rate]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: true,

                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_rate] * [txt_qty]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "VAT%",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_vat",
                Json_Attribute: "vat_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "tax_rates",
                IncludeNotSet: false,
                Default_Value: "1",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vat_amt",
                Json_Attribute: "vat_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Net amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amt",
                Json_Attribute: "net_amt",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Department",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_department",
                Json_Attribute: "department_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "department",
                IsVerticalView: true,
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_9",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_10",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "miscellaneous_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "miscellanious_vat_amount",
                Json_Attribute: "miscellanious_vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Net Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "miscellaneous_net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
          {
            componentType: LayoutTypes.GRID,
            columnNumber: "m1 t2 w3",

            BindValue: "cont_total_amount",
            childComponents: [
              {
                IncludeLabel: true,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "gross_vat_amount",
                Json_Attribute: "gross_vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2:
                  "[(service_spare_est_req).spare_vat_amount] + [(service_labour_est).labour_vat_amount]+[(estimation_miscellaneous).miscellanious_vat_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Discount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_discount",
                Json_Attribute: "discount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Gross amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "gross_amount",
                Json_Attribute: "gross_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2:
                  "[(service_spare_est_req).txt_sub_amount] + [(service_labour_est).txt_sub_amount]+[(estimation_miscellaneous).txt_sub_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: true,
                Label: "Total amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_total_amount",
                Json_Attribute: "est_total_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2:
                  "[(service_spare_est_req).txt_sub_net_amount] + [(service_labour_est).txt_sub_net_amount]+[(estimation_miscellaneous).txt_sub_net_amount] - [txt_discount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
        ],
      },
      {
        componentType: LayoutTypes.GRID,
        columnNumber: "m1 t2 w1 ",
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Save",
            onPressAction: "save",
            style: {
              backgroundColor: "var(--primary-green)",
            },
          },
        ],
      },
    ],
  },
];
